import type { PeticeOsobaDto } from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';
import { nameFormatting } from '@gov-nx/utils/common';

export function formatZakladatelName(
	zakladatel: PeticeOsobaDto | undefined
): string {
	if (zakladatel?.pravnickaOsoba) {
		return zakladatel.pravnickaOsoba.nazev ?? '';
	}
	return nameFormatting(
		zakladatel?.fyzickaOsoba?.jmeno,
		zakladatel?.fyzickaOsoba?.prijmeni
	);
}

export function removeIdFromSubmissionName(name: string): Optional<string> {
	if (typeof name === 'string') {
		const regex = /\[[^\]]*\]\s*-\s/g;
		return name.replace(regex, '');
	}
	return undefined;
}
